import React from 'react';
import PropTypes from 'prop-types';
import { StyledButtonLink } from './style/StyledButtonLink.styled';

export const ButtonLink = ({ text, href, onClick }) => {
    return <StyledButtonLink href={href} onClick={onClick}>{text}</StyledButtonLink>;
};

ButtonLink.propTypes = {
    text: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func
};
